import { createReducer } from '@reduxjs/toolkit';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import { actionManager, buildActionStatus } from '../utils';
import * as ca from './conferenceActions';
import isEmpty from 'lodash/isEmpty';
import omitBy from 'lodash/omitBy';
const initialState = {
  actionStatus: buildActionStatus(ca),
  ConferenceId: null,
  SessionId: null,
  ResourceId: null,
  Title: '',
  Description: '',
  PlaybackUrl: '',
  Videos: [],
  Status: '',
  Standby: {},
  resource: {},
  questions: [],
  thisUsersActiveQuestionCount: 0,
  userQuestionUpdates: {},
  ResourceStatus: {
    Status: '',
    Ivs: '',
    MediaLive: '',
    Viewers: '',
    CurrentInput: '',
  },
  RecordingUserId: '',
  Vod: [],
  blockedUsers: [],
};

const conferenceReducer = createReducer(initialState, {
  [ca.resetStateAction]: () => ({
    ...initialState,
  }),
  [ca.initAction]: (state, { payload: { key } }) =>
    actionManager(state, key, { loading: true, error: '' }),
  [ca.successAction]: (state, { payload: { key } }) =>
    actionManager(state, key, { loading: false, error: '' }),
  [ca.errorAction]: (state, { payload: { key, error } }) =>
    actionManager(state, key, { loading: false, error }),
  [ca.setConferenceAction]: (state, { payload }) => {
    return {
      ...state,
      // ConferenceId: payload.ConferenceId,
      SessionId: payload.SessionId,
      Title: payload.Title,
      Description: payload.Description,
      PlaybackUrl: payload.PlaybackUrl,
      ResourceId: payload.CurrentResourceId,
      Videos: payload.Videos,
      Vod: payload.Vod,
      Standby: payload.Standby,
      Status: payload.Status,
      RecordingUserId: payload.RecordingUserId,
    };
  },
  [ca.setAllQuestionsAction]: (
    state,
    { payload: { questions, thisUsersActiveQuestionCount = null } }
  ) => {
    return {
      ...state,
      questions,
      thisUsersActiveQuestionCount:
        thisUsersActiveQuestionCount === null
          ? state.thisUsersActiveQuestionCount
          : thisUsersActiveQuestionCount,
    };
  },
  [ca.setCachedQuestionsAction]: (
    state,
    { payload: { questions, thisUsersActiveQuestionCount } }
  ) => {
    let updatedState = { ...state };
    if (isEmpty(state.userQuestionUpdates)) {
      updatedState = { ...updatedState, questions, thisUsersActiveQuestionCount };
    }
    return updatedState;
  },
  [ca.setStatusAction]: (state, { payload }) => {
    return {
      ...state,
      ResourceStatus: {
        ...state.ResourceStatus,
        ...omitBy(payload, (x) => {
          return x === null || x === undefined;
        }),
      },
    };
  },
  [ca.setVodResourcesAction]: (state, { payload: { Vod } }) => {
    return {
      ...state,
      Vod: cloneDeep(Vod),
    };
  },
  [ca.clearUserQuestionUpdatesAction]: (state) => ({
    ...state,
    userQuestionUpdates: {},
  }),
  [ca.updateUserQuestionUpdatesAction]: (state, { payload: { questionId, data } }) => {
    let newUserQuestionsUpdates = { ...state.userQuestionUpdates };
    let question = get(newUserQuestionsUpdates, `${questionId}`, {});
    newUserQuestionsUpdates[questionId] = { ...question, ...data };
    return { ...state, userQuestionUpdates: newUserQuestionsUpdates };
  },
  [ca.missNextCacheCallAction]: (state) => ({
    ...state,
    userQuestionUpdates: { ...state.userQuestionUpdates, missNextCacheCall: true },
  }),
  [ca.setBlockedUsersAction]: (state, { payload: { blockedUsers } }) => ({
    ...state,
    blockedUsers,
  }),
});

export default conferenceReducer;
